import React from 'react'
import mailIcon from '../images/email-blanc-2.png';
import wwwIcon from '../images/www-2.png'
import frFlag from '../images/FRAN.png'
import enFlag from '../images/ENGL.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { useLang } from "./Provider/LanguageProvider";

function UpperNavbar() {
  const { language , setLanguage} = useLang();
  const handleMouseOverLang = () => {
    document.getElementById('lang').style.display = 'block';
  }
  const handleMouseLeaveLang = () => {
    document.getElementById('lang').style.display = 'none';
  }

  const switchLang = () => {
    if (language === "fr") {
      setLanguage("en")
    } else {
      setLanguage("fr")
    }
  }

  return (
    <div id='upper-navbar'>
      <div className='container'>
        <div className='left-cont'>
          <img src={mailIcon} alt='mail' />
          <a href='mailto:kinshasa@shenimed.com'>kinshasa@shenimed.com</a>
        </div>
        <div className='right-cont'>
          <img src={wwwIcon} alt='planet' />
          <span>République Démocratique du Congo</span>
          <div className='language-menu' onMouseOver={handleMouseOverLang} onMouseLeave={handleMouseLeaveLang}>
            {language === "fr" ? <img src={frFlag} alt='flag' /> : <img src={enFlag} alt='flag' />}
            <span className='down-arrow'><FontAwesomeIcon icon={faAngleDown} /></span>
            <div className='submenu' id='lang' onClick={switchLang}>
              {language !== "fr" ? <img src={frFlag} alt='flag' /> : <img src={enFlag} alt='flag' />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpperNavbar